import React, { useState, useEffect } from "react";
import { Typography, Result, Spin, Card } from "antd";
import Utilities from "../../dependencies/custom/react-utilities";
import { useNavigate } from "react-router-dom";
// import Settings from '../../dependencies/custom/settings';
import { LoadingOutlined } from "@ant-design/icons";
const { Title } = Typography;
const RedeemCoupon = () => {
  const navigate = useNavigate();
  const [spinning, setSpinning] = useState(true);

  const [data, setData] = useState();
  const [result, setResult] = useState();

  useEffect(() => {
    const params = Utilities.getQString();
    if ("url" in params && "couponcode" in params && "litres" in params) {
      setData(params);
      bootstrap(params);
    } else {
      setSpinning(false);
      setResult(
        <Result
          status="error"
          title={`Fuel Coupon Redemption Failed. Invalid URL`}
        />,
      );
    }
  }, []);

  async function bootstrap(params) {
    const { url, couponcode, litres } = params || {};
    setSpinning(true);
    const res = await Utilities.fetchWithAuth(
      "POST",
      url,
      { litresIssued: litres, couponCode: couponcode },
      navigate,
      "../../redeem_coupon",
    );
    if (res.ok) {
      setResult(
        <Result
          status="success"
          title="Fuel Coupon Redeemed Successfully"
          subTitle={
            <div className="fw-bold h5">
              <div>Code: {couponcode}</div>
              <div>Litres: {litres}</div>
            </div>
          }
        />,
      );
    } else {
      setResult(
        <Result
          status="error"
          title={`Fuel Coupon Redemption Failed. ${res.msg}`}
          subTitle={
            <div className="fw-bold h5">
              <div>Code: {couponcode}</div>
              <div>Litres: {litres}</div>
            </div>
          }
        />,
      );
    }
    setSpinning(false);
  }

  const CouponDisplay = (data) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center", // horizontal center
          alignItems: "center", // vertical center
          height: "100vh", // full screen height
        }}
      >
        <Card
          style={{
            width: 300,
            textAlign: "center", // center text inside card
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)", // subtle shadow
          }}
        >
          <div style={{ marginBottom: "16px" }}>
            <Title level={5} strong>
              Coupon Code: {data?.couponcode}
            </Title>
          </div>
          <div>
            <Title level={5} strong>
              Litres: {data?.litres}
            </Title>
          </div>
        </Card>
      </div>
    );
  };

  return (
    <>
      {result ? result : CouponDisplay(data)}
      <Spin
        indicator={<LoadingOutlined />}
        style={{ fontSize: 48 }}
        spinning={spinning}
        fullscreen
      />
    </>
  );
};
export default RedeemCoupon;
